const Header = ((($) => {

  function init() {
    $(window).scroll(function() {
      $(this);
      if ($(window).scrollTop() >= 10) {
        $('.Header').addClass('Header--fixed');
      }
      else {
        $('.Header').removeClass('Header--fixed');
      }
    });
  }
  return {
    init,
  };

}))(jQuery);

export default Header;



// WEBPACK FOOTER //
// ./src/static/js/modules/header.js